module.exports = __webpack_public_path__ + "static/media/etm.b2c1a2b9.jpeg";